import EngineManagerForm from '../../../../components/Admin/Engines/EngineManagerForm'
import { Typography, Button } from '@mui/material'
import { DoneOutline } from '@mui/icons-material'
import { Grid } from '../../../../components/UniversalComponents'

const Step2Engine = ({ setNextStep, permissionsCheck, endQuickStart }) => {
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography
                    align="center"
                    variant="h5"
                    color="warning"
                    sx={{ margin: 2 }}
                >
                    If you already have a configured engine model you can:
                    {
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={endQuickStart}
                            sx={{ width: 200, marginLeft: 5 }}
                            endIcon={<DoneOutline />}
                        >
                            End Quick Start
                        </Button>
                    }
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <EngineManagerForm
                    row={{}}
                    onClose={endQuickStart}
                    saveCache={() => {}}
                    permissionCheck={permissionsCheck}
                    quickStart={true}
                    blobInfo={() => {}}
                />
            </Grid>
        </Grid>
    )
}
export default Step2Engine
